"use client";

import ImageSimple from "@/library/components/images/ImageSimple";
import React from "react";

export default function ImageSimpleBlock({ blok }) {
  const { image, position, size, backgroundColor } = blok;

  const { filename, alt } = image || {};

  return (
    <ImageSimple
      filename={filename}
      alt={alt}
      position={position}
      size={size}
      backgroundColor={backgroundColor}
    />
  );
}
